import { useAxiosContext } from "../../../context/AxiosContext";
import { useTreeContext } from "../../../context/TreeDataContext";
import { useStatemachineContext } from "../../../context/StatemachineContext";
import React, { useEffect, useState } from "react";
import Loader from "../../../Layouts/Loader/Loader";
import StateOptionsEditor from "./StateOptionsEditor";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import { getFolderFileById } from "../../../utils/treeData/folderEditorUtils";
import { useNavigate, useParams } from "react-router-dom";

const StateRenderer = () => {
  const { axiosInstance, handleError } = useAxiosContext();
  const { stateMachineExplorerData } = useTreeContext();
  const { rememberData, setRememberData, setSelectedStateMachine } = useStatemachineContext();
  const [activeSM, setActiveSM] = useState({ states: [], activities: [] });
  const [toggleState, setToggleState] = useState(true);
  const [isLoader, setIsLoader] = useState(true);
  const [error, setError] = useState("");
  const { textareaValue, setTextareaValue } = useStatemachineContext();
  const { stateId, smId } = useParams();
  const navigate = useNavigate();
  const [smName, setSmName] = useState("");

  const fetchSingleState = async () => {
    try {
      setIsLoader(true);
      setError("");

      const { data } = await axiosInstance.get(`/state-machine/${smId}/states/${stateId}`);

      const { data: smData } = await axiosInstance.get(`/state-machine/${smId}`);
      setSmName(smData.config?.name || "");

      setActiveSM({
        states: smData.config?.states || [],
        activities: smData.config?.activities || [],
        gateways: smData?.config?.gateways || []
      });

      setRememberData(data.remember);
      setTextareaValue(data.description);
    } catch (error) {
      setError(error?.response?.data?.message || "Something went wrong");
      handleError(error);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    fetchSingleState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId, smId]);

  useEffect(() => {
    if (!stateMachineExplorerData) return;

    const file = getFolderFileById(stateMachineExplorerData, `${smId}/states/${stateId}`);
    if (file) {
      const obj = {
        id: `${smId}/states/${stateId}`,
        name: file.name,
        stateid: smId,
        statename: "states"
      };
      setSelectedStateMachine(obj);
      const selectedObject = stateMachineExplorerData.find((st) => st.id === obj.stateid);
      setSmName(selectedObject?.name);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId, smId]);

  const handleNotesAndTag = (data) => {
    setTextareaValue(data);
  };

  if (isLoader) return <Loader />;

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  return (
    <StateOptionsEditor
      rememberData={rememberData}
      setRememberData={setRememberData}
      textareaValue={textareaValue}
      handleNotesAndTag={handleNotesAndTag}
      activeSM={activeSM}
      setToggleState={setToggleState}
      toggleState={toggleState}
      smName={smName}
    />
  );
};

export default StateRenderer;
